import { render, staticRenderFns } from "./download-signature.vue?vue&type=template&id=c6797bba&scoped=true&"
import script from "./download-signature.vue?vue&type=script&lang=tsx&"
export * from "./download-signature.vue?vue&type=script&lang=tsx&"
import style0 from "./download-signature.vue?vue&type=style&index=0&id=c6797bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6797bba",
  null
  
)

export default component.exports